export const fadeCondition = ({
	scrollButton,
	scrollStart,
	scrollEnd,
}: {
	scrollButton: boolean;
	scrollStart: number;
	scrollEnd: boolean;
}) => {
	if (!scrollButton) {
		return '';
	}
	if (scrollStart === 0) {
		return 'linear-gradient(90deg, black 90%, transparent 100%)';
	} else if (!scrollEnd) {
		return 'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)';
	} else {
		return 'linear-gradient(270deg, black 90%, transparent 100%)';
	}
};
